export const TEXTS = {
  POLLING_TIMEOUT: 'Превышено время ожидания получения данных',
  POLLING_TOO_MANY_ATTEMPTS: 'Превышено количество попыток получения данных',
};
